import { queryClient, useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services/api';
import { deleteProgramEvent } from '../../services';
import { getEventDetailQueryKey, getEventsQueryKey } from '../keys';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Something went wrong. The event couldn’t be deleted.');
};

export const useDeleteProgramEventMutation = () =>
  useMutation<unknown, { eventId: string }>({
    defaultMutateOnError,
    async mutationFn({ eventId }) {
      await deleteProgramEvent({ eventId });
    },
    async onSuccess(_, { eventId }) {
      await queryClient.invalidateQueries({ queryKey: getEventsQueryKey({}) });
      queryClient.removeQueries({ queryKey: getEventDetailQueryKey({ id: eventId }) });
    },
  });
